import React, { Component } from 'react'
import Axios from '../../../config/axios'
import withErrorHandler from 'hoc/withErrorHandler'
import { PageHeader, Col, List, Button } from 'antd'
import { Link } from 'react-router-dom'

class Leaflet extends Component {

    state ={
        leaflets: []        
    }

    componentDidMount() {
        this.fetchLeaflet()
    }

    fetchLeaflet = () => {
        Axios.get("leaflets").then(response => {
            this.setState({ leaflets: response.data.payload })
        })
    }

    render() {        
        return(
            <div className="site-layout-background" style={{ padding: 10, minHeight: 360 }}>
                <PageHeader
                    className="site-page-header"
                    onBack={() => null}
                    backIcon={null}
                    title="Surat Edaran"
                    subTitle="daftar surat"
                />
                <Col>
                <List
                    size="large"                    
                    dataSource={this.state.leaflets}
                    renderItem={item => 
                        <List.Item>
                            <Col>
                            <h4>{item.title}</h4>
                            <Link to={"/admin/edaran/buat-edaran/"+ item._id}>
                                <Button type="primary">Buat Surat</Button>
                            </Link>
                            </Col>
                        </List.Item>}
                    />
                </Col>
            </div>
        )
    }
}

export default withErrorHandler(Leaflet, Axios)